export default "https://cdn-gra.amplement.io/statics/images/empty-image-196x196.png";